import React, { useState } from "react";
import {
  Box,
  Paper,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Checkbox,
  Button,
  Modal,
  Link,
} from "@mui/material";
import DeleteIcon from "../../assets/images2/deleteIcon.svg";

const DeleteModal = ({
  deleteSelected,
  video,
  handleTournamentVideoDelete,
}) => {
  const [openDelete, setOpenDelete] = useState(false);
  const [deleteSelect, setDeleteSelect] = useState(false);
  // const handleTournamentDelete = () => {};
  return (
    <>
      <Button
        variant="text"
        onClick={() => {
          deleteSelected.current = video;
          setOpenDelete(true);
        }}
      >
        <img src={DeleteIcon} alt="" />
      </Button>
      <Modal
        open={openDelete}
        onClose={() => setOpenDelete(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="deleteModal">
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Are You sure . You want to delete this Tournament video.
          </Typography>
          <Box className="buttons-div">
            <Button variant="outlined" onClick={() => setOpenDelete(false)}>
              cancel
            </Button>
            <Button
              variant="outlined"
              onClick={() => {
                handleTournamentVideoDelete(deleteSelected);
                setOpenDelete(false);
                setDeleteSelect(true);
              }}
            >
              {deleteSelect ? "Deleting..." : "Delete"}
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default DeleteModal;
